<template>
  <div class="sign_form" @keydown="keydown">
    <header><span class="header_sign_text">{{ t('login.registerTitle') }}</span><span>{{ t('login.hasAccount') }}<span class="direct" @click="$FN.visibleLogin(1)">{{ t('login.loginDirect') }}</span><a-icon type="close" @click.stop="$FN.visibleLogin()" /></span></header>
    <AntForm :data="form" :rows="1" ref="AntForm" :key="key" />
    <a-button block type="primary" class="ant_btn_login" :loading="signLoading" @click="sign">{{ t('login.registerNow') }}</a-button>
  </div>
</template>

<script>
import { t } from '@/locales';
export default {
  data() {
    return {
      key: 0,
      form: {},
      loading: false,
      signLoading: false,
      emailCodeLoading: false,
      num: 0,
      timer: null,
      userNameFlag: false,
      emailFlag: false,
      phoneFlag: false,
      passwordFlag: false,
      time: null
    }
  },
  created() {
    this.setForm();
  },
  beforeDestroy() {
    this.clearTime();
  },
  watch: {
    '$store.state.language'() {
      this.setForm();
    }
  },
  methods: {
    t,
    clearTime() {
      clearTimeout(this.time);
      this.time = null;
    },
    // 用户敲击回车
    keydown(e) {
      // 与表单change发生冲突，将任务放到宏任务中
      if (e.keyCode === 13) this.time = setTimeout(this.sign, 250);
    },
    sign() {
      this.clearTime();
      this.$refs.AntForm.validateFields((err, { confirmpassword, mailCode, username, ...rest }) => {
        if (!err) {
          let { userNameFlag = false, emailFlag = false, phoneFlag, passwordFlag = false } = this;
          if (!userNameFlag) return this.$message.error(t('login.accountRegistered'));
          if (!emailFlag) return this.$message.error(t('login.emailRegistered'));
          if (!phoneFlag) return this.$message.error(t('login.phoneRegistered'));
          if (!passwordFlag) return this.$message.error(t('login.passwordMismatch'));
          this.signLoading = true;
          let form = { username, nickName: username, ...rest };
          this.$FN.post(`open/api/users/register/PES/${mailCode}`, form).then(res => {
            this.signLoading = false;
            if (res) {
              let { code = 500, msg = t('individualCenter.networkError') } = res;
              if (code === 100) {
                this.$message.success(msg);
                this.$FN.visibleLogin(1);
              } else {
                this.$message.error(msg);
              }
            }
          })
        }
      });
    },
    getEmailCode() {
      this.$refs.AntForm.form.validateFields(['email'], (err, form) => {
        if (!err) {
          this.emailCodeLoading = true;
          let { email = null } = form;
          this.$FN.get("open/api/users/send/email/code", { email }).then(res => {
            this.emailCodeLoading = false;
            if (res) {
              let { code = 500, msg = "" } = res;
              if (code === 100) {
                this.emailFlag = true;
                this.setTimer();
                this.$message.success(msg);
              } else {
                this.emailFlag = false;
                this.$message.error(msg);
              }
            };
          })
        }
      });
    },
    setTimer() {
      this.num = 120;
      this.timer = setInterval(() => {
        this.num -= 1;
        if (!this.num) {
          clearInterval(this.timer);
          this.timer = null;
        };
      }, 1000);
    },
    mailboxCheck(key = null) {
      // let { username = null, email = null, password = null, confirmpassword = null } = this.$refs.FORM.getForm();
      this.$refs.AntForm.form.validateFields(['email', 'username', 'phone', 'password', 'confirmpassword'], (err, { email, username, phone, password, confirmpassword }) => {
        // 查看账号与邮箱手机号是否已经注册
        (key === 'userName') && username && this.inspectUserName(username);
        (key === 'email') && email && this.inspectEmail(email);
        (key === 'phone') && email && this.inspectPhone(phone);

        if ((password && confirmpassword) && password !== confirmpassword) {
          this.passwordFlag = false;
          return this.$message.error(t('login.passwordMismatch'));
        } else {
          this.passwordFlag = true;
        }
      });
    },
    inspectUserName(userName) {
      let config = { contentType: "0" };
      // api/user_service/reg/checkRegistUserName 原接口
      this.$FN.post("/open/api/users/checkUsernameExist", { userName }, config).then(res => {
        if (res) {
          let { code = 500, msg = t('individualCenter.networkError') } = res;
          if (code === 100) {
            this.userNameFlag = true;
            this.$message.success(t('login.usernameAvailable'))
          } else {
            this.userNameFlag = false;
            this.$message.error(msg);
          }
        }
      })
    },
    inspectEmail(email) {
      let config = { contentType: "0" };
      // api/user_service/reg/checkRegistEmail 原接口
      this.$FN.post("/open/api/users/checkEmailExist", { email }, config).then(res => {
        if (res) {
          let { code = 500, msg = t('individualCenter.networkError') } = res;
          if (code === 100) {
            this.emailFlag = true;
            this.$message.success(t('login.emailAvailable'))
          } else {
            this.emailFlag = false;
            this.$message.error(msg);
          }
        }
      })
    },
    inspectPhone(phone) {
      let config = { contentType: "0" };
      this.$FN.post("/open/api/users/checkPhoneExist", { phone }, config).then(res => {
        if (res) {
          let { code = 500, msg = t('individualCenter.networkError') } = res;
          if (code === 100) {
            this.phoneFlag = true;
            this.$message.success(t('login.phoneAvailable'))
          } else {
            this.phoneFlag = false;
            this.$message.error(msg);
          }
        }
      })
    },
    setForm() {
      this.form = {
        username: {
          label: t('login.account'),
          placeholder: t('login.accountPlaceholder'),
          prefixIcon: "iconfont icon-pes_icon_line_yonghuming",
          clearable: true,
          on: { 'blur': () => this.mailboxCheck("userName") },
          rules: [
            { required: true, message: t('login.accountRequired'), trigger: 'blur' },
            { min: 2, max: 20, message: t('login.usernameLength'), trigger: 'blur' },
            { ...this.$RULES.noSpace, message: t('login.noSpace') },
          ],
        },
        email: {
          label: t('login.email'),
          placeholder: t('login.emailPlaceholder'),
          prefixIcon: "iconfont icon-pes_icon_line_youxiang",
          clearable: true,
          on: { 'blur': () => this.mailboxCheck("email") },
          rules: [
            { required: true, message: t('login.emailRequired'), trigger: 'blur' },
            { ...this.$RULES.email, message: t('login.emailFormat') },
          ],
        },
        phone: {
          label: t('login.phone'),
          placeholder: t('login.phonePlaceholder'),
          prefixIcon: "iconfont icon-pes_icon_line_shouji",
          clearable: true,
          on: { 'blur': () => this.mailboxCheck("phone") },
          rules: [
            { required: true, message: t('login.phoneRequired'), trigger: 'blur' },
            { ...this.$RULES.phone, message: t('login.phoneFormat') },
          ],
        },
        password: {
          label: t('login.password'),
          type: "password",
          placeholder: t('login.passwordPlaceholder'),
          prefixIcon: "iconfont icon-pes_icon_line_mima",
          showPassword: true,
          on: { 'blur': this.mailboxCheck },
          rules: [
            { required: true, message: t('login.passwordRequired'), trigger: 'blur' },
            { min: 8, max: 16, message: t('individualCenter.passwordLength'), trigger: 'blur' },
            { ...this.$RULES.weakPassword, message: t('login.weakPassword') },
          ],
        },
        confirmpassword: {
          label: t('individualCenter.confirmPassword'),
          type: "password",
          placeholder: t('login.confirmPasswordPlaceholder'),
          prefixIcon: "iconfont icon-pes_icon_line_mima",
          showPassword: true,
          on: { 'blur': this.mailboxCheck },
          rules: [
            { required: true, message: t('individualCenter.confirmPasswordRequired'), trigger: 'blur' },
            { min: 8, max: 16, message: t('individualCenter.passwordLength'), trigger: 'blur' },
            { ...this.$RULES.weakPassword, message: t('login.weakPassword') },
          ],
        },
        mailCode: {
          label: t('login.emailCode'),
          value: "",
          rules: [{ required: true, message: t('login.captchaRequired'), trigger: 'blur' }],
          render: a => {
            return (
              <div class="render_code">
                <div class="left_input">
                  <a-input v-decorator={['mailCode', { rules: [{ required: true, message: t('login.captchaRequired'), trigger: 'blur' }] }]} placeholder={t('login.codePlaceholder')} />
                </div>
                <div class="right_btn">
                  <a-button type="primary" style={{ opacity: this.mailCodeOpacity }} loading={this.emailCodeLoading} disabled={!!this.timer} onClick={this.getEmailCode}>{this.timer ? (this.$store.state.language === 'english' ? `Resend in ${this.num}s` : `${this.num}秒后获取邮箱验证码`) : t('login.sendEmailCode')}</a-button>
                </div>
              </div>
            )
          }
        }
      };
      this.key = Math.random();
    }
  }
}
</script>

<style lang="less" scoped>
@import url("./index.less");
</style>
